<template>
<div id="purchasable-item-search">
  <search-form
    :pageRef="$parent"
    :searchUrl="searchUrl"
    inputType="email"
  />
</div>

</template>
<script>
import SearchForm from '@/components/PagedSearchFieldForm'

export default {
  computed: {
    searchUrl () {
      return this.apiUrl('/newsletter_types/' + this.newsletterTypeId + '/search', true)
    }
  },

  props: {
    newsletterTypeId: {
      type: [ Number, String ],
      default: undefined,
      required: true
    }
  },

  components: {
    'search-form': SearchForm
  }
}
</script>



// WEBPACK FOOTER //
// src/components/NewsletterTypeSubscriberSearch.vue